import React from 'react';

const NewShortcutComponent = ({ keysData, title }) => {
  return (
    <div className="new-shortcuts-modal">
      <h3 className="new-shortcuts-modal-heading">{title}</h3>
      <div className="new-shortcuts-table">
        <div className="new-shortcuts-table-column">
          {keysData.slice(0, Math.ceil(keysData.length / 2)).map((item, index) => (
            <div key={index} className="new-shortcuts-item">
              <div className="new-shortcuts-item-title-section">
                <div className="new-shortcuts-title">{item.title}</div>
              </div>
              <div className="new-shortcuts-keys-section">
                {item.keys.map((key) => {
                  return (
                    <span className="new-shortcut-key" key={key}>
                      {key}
                    </span>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
        <div className="new-shortcuts-table-column">
          {keysData.slice(Math.ceil(keysData.length / 2)).map((item, index) => (
            <div key={index} className="new-shortcuts-item">
              <div className="new-shortcuts-item-title-section">
                <div className="new-shortcuts-title">{item.title}</div>
              </div>
              <div className="new-shortcuts-keys-section">
                {item.keys.map((key) => {
                  return (
                    <span className="new-shortcut-key" key={key}>
                      {key}
                    </span>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewShortcutComponent;
